import assetPath from '/app/packages/lebenslauf/articles/src/assets/erfolgreich-bewerben-wie-du-deine-soft-skills-effektiv-praesentierst.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')